import axios from "axios";
import { BASE_URL_API } from "../initUrls";

const createAxios = () => axios.create({
    baseURL: BASE_URL_API,
})

const createAxiosWithToken = (token) => axios.create({
    baseURL: BASE_URL_API,
    headers: {
        Authorization: 'Bearer ' + token,
    }
})

const createAxiosWithTokenFile = (token) => axios.create({
    baseURL: BASE_URL_API,
    headers: {
        Authorization: 'Bearer ' + token,
        ContentType: 'multipart/form-data',
    }
})

export {createAxios, createAxiosWithToken, createAxiosWithTokenFile}